
import VueBarcode from "vue-barcode";
export default {
  components: {
    barcode: VueBarcode
  },
  props: {
    barcodeText: {
      type: String,
      default: ""
    }
  }
};
